import CoreRecentFeaturedNewsInsights from './CoreRecentFeaturedNewsInsights';

export { type CoreRecentFeaturedNewsInsightsProps } from './CoreRecentFeaturedNewsInsights';
export default CoreRecentFeaturedNewsInsights;
